import api from './config/api';
import { objToQuery } from 'utils/query';

interface IFormData {
  idCliente?: number;
  dataInicial?: string;
  dataFinal?: string;
  periodoInicial: string;
  periodoFinal: string;
}

export const getDetailedTimeTracking = async (data: IFormData) => {
  return api.get(`/controle-orcamentario/export-excel-historico-horas?${objToQuery(data)}`, {
    responseType: 'blob',
  });
};
